import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import {Form, Formik} from "formik"
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../../component/common/CustomPagination";
import { koKRGrid } from "../../../component/common/TableKRText";
// import SampleDetailDialog from "./SampleDetailDialog"
import api from "../../../../API";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../component/common/SearchBackDrop";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function getKoreaTime(date: Date): Date {
  const koreaOffset = 9 * 60; // 한국은 UTC+9
  const utcTime = date.getTime();
  const koreaTime = new Date(utcTime + koreaOffset * 60000);
  return koreaTime;
}

function getSaturday(date: Date): Date {
  const dayOfWeek = 6; // 토요일
  const currentDate = new Date(date);
  
  while (currentDate.getDay() !== dayOfWeek) {
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return currentDate;
}

function getNextSaturday(date: Date): Date {
  const dayOfWeek = 6; // 토요일
  const currentDate = new Date(date);
  
  while (currentDate.getDay() !== dayOfWeek) {
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  // currentDate.setDate(currentDate.getDate() + 7); // 다음 주 토요일
  currentDate.setDate(currentDate.getDate()); // 다음 주 토요일
  return currentDate;
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// function CustomToolbar(props: any) {

//   // console.log('CustomToolbar props :::: ' , props)

//   const a = new Date();

//   const year = a.getFullYear();
//   const month = (a.getMonth() + 1).toString().padStart(2, '0'); 
//   const day = a.getDate().toString().padStart(2, '0'); 

//   // console.log('오늘 날짜' , year + '-'+month + '-'+ day )

//   const today = new Date(year + '-'+month + '-'+ day); // 오늘 날짜
//   const startDate = new Date('2023-08-19'); // 시작 날짜

//   const koreaToday = getKoreaTime(today);
//   const saturday = getSaturday(startDate);
//   const nextSaturday = getNextSaturday(koreaToday);

//   const dateRange: { start: string; end: string }[] = [];
  
//   let currentDate = new Date(saturday);
//   while (currentDate <= nextSaturday) {
//     dateRange.push({
//       start: formatDate(currentDate),
//       end: formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 6)) // 금요일
//     });
//     currentDate.setDate(currentDate.getDate() + 7); // 다음 주 토요일
//   }

//   return (
//     <GridToolbarContainer>
//       <GridToolbarColumnsButton />
//       <GridToolbarFilterButton />
//       <GridToolbarExport
//         csvOptions={{
//           utf8WithBom: true,
//         }}
//       />
//       <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        
//       </Box>
//       <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
//       {/* <GridToolbarQuickFilter /> */}
//     </GridToolbarContainer>
//   );
// }

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const ScriptConfirmStatusTable = () => {

  const [page, setPage] = useState(1);

  // const [state, setState] = useState('스크립트제출');
  const [uploadDate, setUploadDate] = useState('');

  const [worker, setWorker] = useState('');

  const [p_uploadDate, setP_uploadDate] = useState('');
  const [p_worker, setP_worker] = useState('');

  const setUploadParam = () => {
    setP_uploadDate(uploadDate);
  }

  const setWorkerParam = () => {
    setP_worker(worker);
  }

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<any>({
    idx: 0,
    email: "",
    name: "",
    min_ins_date: "",
    max_ins_date: "",
    upload_count: 0,
    confirm_count: 0,
    reject_count: 0,
    total_count: 0
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [totalCount, setTotalCount] = useState(0);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  const scriptFileWorker = async (workDate:string) => {
    console.log('workDate',workDate)
    setBackdrop(true)
    var result = await api.get("/getScriptFileWorker", {
      params: {email:email,workDate:workDate}
    });
    console.log("스크립트 검토인력", result.data.datas);
    setBackdrop(false)

    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        idx: idx+1,
        isp_email: data.isp_email,
        isp_name: data.isp_name,
        asg_cnt: data.asg_cnt,
        total_cnt: data.reject_cnt+data.confirm_cnt,
        reject_cnt: data.reject_cnt,
        confirm_cnt: data.confirm_cnt
      };
    });

    setRows(datas)

    var result_count = await api.get("/getScriptFileWorkerCount", {
      params: {email:email}
    });

    console.log('할당할 수 있는 스크립트 카운트' ,result_count.data.datas )

    setTotalCount(result_count.data.datas)
    
  };

  const [p_DateRange, setP_DateRange] = useState<any>([])
  const dateRange: { day: string }[] = [];


  const readyDay = () => {

  
    const a = new Date();

    const year = a.getFullYear();
    const month = (a.getMonth() + 1).toString().padStart(2, '0'); 
    const day = a.getDate().toString().padStart(2, '0'); 

    // console.log('오늘 날짜' , year + '-'+month + '-'+ day )

    setP_todayDate(year + '-'+month + '-'+ day)
    setP_workDate(year + '-'+month + '-'+ day)


    const today = new Date(year + '-'+month + '-'+ day); // 오늘 날짜
    const startDate = new Date('2023-09-01'); // 시작 날짜

    const koreaToday = getKoreaTime(today);
    // const saturday = getSaturday(startDate);
    // const nextSaturday = getNextSaturday(koreaToday);

    
    let currentDate = new Date(today);

    // console.log('dateRange 전',dateRange)
    // console.log('currentDate',currentDate)
    // console.log('startDate',startDate)

    while (currentDate > startDate) {
      dateRange.push({
        day: formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()))
        // end: formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 6)) // 금요일
      });
      currentDate.setDate(currentDate.getDate() - 1); // 다음 주 토요일
      
    }

    // console.log('dateRange 후',dateRange)

    setP_DateRange(dateRange)

    scriptFileWorker(year + '-'+month + '-'+ day);

  }

  const goAssignMentScriptFile = async (data:any) => {
    setBackdrop(true)
    // console.log('goAssignMent' , data)
    // return ;
    api.post('/scriptFileAssignMent',data)
    .then((res:any) => {setBackdrop(false);console.log("할당완료", res.data.datas); alert("스크립트 할당 완료.\n 워커 : " + data.worker + " \n 할당 :" + data.work_cnt + "건"); scriptFileWorker(p_workDate); })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {setBackdrop(false);console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const [p_todayDate, setP_todayDate] = useState('2023-09-01');
  const [p_workDate, setP_workDate] = useState('2023-09-01');

  useEffect(() => {
    readyDay();
  }, []);

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"},
        ".MuiDataGrid-cellContent": {fontSize : "12px", cursor:"pointer"},
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>할당 현황 - 스크립트 검토</h3></Box>
        <Box sx={{ height: "600px", width: "100%",position:"relative" }}>
          {backdrop && ( <SearchBackDrop message={"처리중..."} /> )}
          {/* <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            rowHeight={38}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
                totalCount:totalCount,
                // state: state,
                // setState: setState,
                uploadDate: uploadDate,
                setUploadDate: setUploadDate,
                setUploadParam: setUploadParam,
                selectCheckCnt: selectCheckCnt,
                worker: worker,
                setWorker: setWorker,
                setWorkerParam: setWorkerParam,
                p_workDate: p_workDate,
                setP_workDate: setP_workDate,
              },
            }}
            getRowId={(row) => row.idx}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            onFilterModelChange={(e) => console.log('이벤트!!!',e)}
            // onFilterModelChange={handleFilterModelChange}
            // sx={{cursor:"pointer"}}
          /> */}
          <Box sx={{display:"flex"}}>
            <Box sx={{marginLeft:"8px", color:"#1976d2"}}>작업날짜</Box>
            <Select id="workDate" value={p_workDate} onChange={(e)=> { console.log('워크 데이트',e.target.value);setP_workDate(e.target.value);scriptFileWorker(e.target.value);}}  sx={{width:"350px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
              {p_DateRange.length > 0 && 
                p_DateRange.map((date:any,index:number) =>{
                  // console.log('날짜', date)
                  let dateStart = date.day
                  return <MenuItem key={index+1} dense value={dateStart}>{dateStart}</MenuItem>
                }
                )
              }
            </Select>
          </Box>
          <Box sx={{margin:"16px",width:"670px",fontSize:"24px",backgroundColor:"#03cf5d",color:"#fff",padding:"8px",borderRadius:"5px"}}>할당 대기 : {totalCount} 건</Box>
          <Box sx={{fontSize:"14px", display:"flex", margin:"16px", alignItems: "center"}}>
            <Box sx={{width:"280px",textAlign:"center",color: "#fff",borderRadius: "4px",backgroundColor: "#95b1d1",border: "3px solid #95b1d1"}}>이름</Box>
            <Box sx={{width:"120px",textAlign:"center",color: "#fff",borderRadius: "4px",backgroundColor: "#95b1d1",border: "3px solid #95b1d1"}}>할당건</Box>
            <Box sx={{width:"120px",textAlign:"center",color: "#fff",borderRadius: "4px",backgroundColor: "#95b1d1",border: "3px solid #95b1d1"}}>검토완료</Box>
          </Box>
          {rows.length > 0 ? rows.map((row:any, idx:number) => (
            <React.Fragment key={idx+1}>
              <Formik
                initialValues={{email:email,worker:row.isp_email, work_cnt:0}}
                onSubmit={(values) => {
                  console.log(values);
                  goAssignMentScriptFile(values);
                }}
              >
                {({ values, handleChange, setFieldValue, submitCount }) => (
                  <Form>
                  
                  <Box sx={{fontSize:"14px", display:"flex", margin:"16px", alignItems: "center"}}>
                    <Box sx={{width:"280px"}}>{row.isp_name} ({row.isp_email})</Box>
                    <Box sx={{width:"120px",textAlign:"center"}}>{row.asg_cnt}</Box>
                    <Box sx={{width:"140px",textAlign:"center"}}>
                      <Box>처리: <b style={{color:"blue"}}>{row.total_cnt}</b></Box>
                      <Box>적합: <b style={{color:"#03cf5d"}}>{row.confirm_cnt}</b> / 부적합: <b style={{color:"red"}}>{row.reject_cnt}</b></Box>
                    </Box>
                    <TextField sx={{width:"80px",marginLeft:"24px"}} id="work_cnt" name="work_cnt" size="small" type="number"
                      value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                      onChange={(e) => {
                        const inputValue = parseInt(e.target.value, 10);
                        if(inputValue > totalCount){
                          setFieldValue("work_cnt", totalCount);
                        }else{
                          setFieldValue("work_cnt", inputValue);
                        }
                      }}
                    />
                    
                    {p_workDate === p_todayDate ? (submitCount ? <Button variant="contained" sx={{backgroundColor:"#03cf5d"}}>완료</Button>: <Button variant="contained" type="submit">할당</Button>):""}
                    
                  </Box>
                  
                  </Form>
                )}
              </Formik>
            </React.Fragment>
          )):""}
        </Box>
      </ThemeProvider>
      {/* {dialogOpen == true ? (
        <ScriptFileStatusDetailDialog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getScriptFileStatus={getScriptFileStatus}
          // getScriptFileList={getScriptFileList}
        />
      ) : ""} */}
    </Box>
  );
};
export default ScriptConfirmStatusTable;
